
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":".979","d":"M13.855 12.236a3.17 3.17 0 0 0 1.394-1.513 3.14 3.14 0 0 0 .168-2.045 3.16 3.16 0 0 0-1.131-1.717 3.2 3.2 0 0 0-1.954-.666h-.802a5.05 5.05 0 0 0-1.051-2.012 5.1 5.1 0 0 0-1.83-1.354 5.13 5.13 0 0 0-4.444.163c-.68.359-1.27.866-1.724 1.484a5.04 5.04 0 0 0-.793 4.347c.207.736.58 1.417 1.09 1.99m3.102 1.222 2.628 2.628m0 0 2.63-2.63m-2.63 2.63v-6.57"}})])
          )
        }
      }
    